export default __webpack_public_path__ + "static/girls-2fcb149b488ed2dfc16fc174fa5a88e3.jpg";